module.exports = __webpack_public_path__ + "static/mobile-der-drangsal-ec3a74374d634ff70f5daca792ed0568.jpg";